import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from '@/components/admin/AdminLayout';
import AdminOverviewPage from './admin/AdminOverview';
import AdminUsersPage from './admin/AdminUsers';
import AdminDocumentsPage from './admin/AdminDocuments';
import AdminMediaPage from './admin/AdminMedia';
import AdminCleanupPage from './admin/AdminCleanup';
import AdminFeedbacksPage from './admin/AdminFeedbacks';
import AdminPlansPage from './admin/AdminPlans';
import AdminMissionsPage from './admin/AdminMissions';
import AdminMissionParticipantsPage from './admin/AdminMissionParticipants';
import AdminWheelPage from './admin/AdminWheel';
import AdminBusinessTests from './admin/AdminBusinessTests';
import AdminAI from './admin/AdminAI';
import AdminAuditPage from './admin/AdminAudit';
import AdminCronLogs from './admin/AdminCronLogs';
import AdminTelemetry from './admin/AdminTelemetry';
import AdminTestsPage from './admin/AdminTests';
import AdminPhotoMigration from './admin/AdminPhotoMigration';
import AdminPendenciasPage from './admin/AdminPendencias';
import AdminEmailTemplates from './admin/AdminEmailTemplates';
import AdminEmailTemplateEditor from './admin/AdminEmailTemplateEditor';
import AdminEmailLogs from './admin/AdminEmailLogs';

// Seções acessíveis para moderadores
const moderatorAccessibleRoutes = [
  'overview',
  'pendencias',
  'users', 
  'documents',
  'media',
  'audit'
];

const AdminPanel = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminLayout />}>
        {/* Redirect /main/joia/admin to /main/joia/admin/overview */}
        <Route index element={<Navigate to="overview" replace />} />
        
        {/* Rotas acessíveis para moderadores */}
        <Route path="overview" element={<AdminOverviewPage />} />
        <Route path="pendencias" element={<AdminPendenciasPage />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="documents" element={<AdminDocumentsPage />} />
        <Route path="media" element={<AdminMediaPage />} />
        <Route path="audit" element={<AdminAuditPage />} />
        
        {/* Rotas exclusivas para admins - moderadores serão redirecionados pelo AdminLayout */}
        <Route path="cleanup" element={<AdminCleanupPage />} />
        <Route path="feedbacks" element={<AdminFeedbacksPage />} />
        <Route path="plans" element={<AdminPlansPage />} />
        <Route path="missions" element={<AdminMissionsPage />} />
        <Route path="missions/:missionId/participants" element={<AdminMissionParticipantsPage />} />
        <Route path="wheel" element={<AdminWheelPage />} />
        <Route path="business" element={<AdminBusinessTests />} />
        <Route path="ai" element={<AdminAI />} />
        <Route path="cron-logs" element={<AdminCronLogs />} />
        <Route path="telemetry" element={<AdminTelemetry />} />
        <Route path="tests" element={<AdminTestsPage />} />
        <Route path="photo-migration" element={<AdminPhotoMigration />} />
        <Route path="email-templates" element={<AdminEmailTemplates />} />
        <Route path="email-templates/:id" element={<AdminEmailTemplateEditor />} />
        <Route path="email-logs" element={<AdminEmailLogs />} />
      </Route>
    </Routes>
  );
};

export default AdminPanel;
